/**
 * Applies admin color settings to the shadow host so components that use
 * `var(--color-brand)`, `var(--color-surface)`, etc. pick up the chatbot
 * configuration (panel background, accent, muted/typing chip tone).
 */
export function applyConfThemeVarsToHost(host, conf) {
  if (!host || !conf) return
  const t = (v) => {
    if (v == null) return ''
    const s = String(v).trim()
    return s
  }
  const set = (name, value) => {
    const s = t(value)
    if (s) host.style.setProperty(name, s)
  }
  set('--color-brand', conf.widgetButtonColor)
  set('--color-brand-foreground', conf.widgetButtonTextColor)
  set('--color-surface', conf.widgetPanelBackgroundColor)
  const botBg = t(conf.widgetBotMessageBackgroundColor)
  if (botBg) host.style.setProperty('--color-muted', botBg)
}
